import { Maybe } from '@/utils/types'
import { ContentInteraction } from '../useContentInteraction'

type Surface = 'discover' | 'brand_landing' | 'player'
type ItemType = 'ContentMovie' | 'ContentSpecial' | 'ContentSeries'

/**
 * Interaction builder for recommended titles in rails
 * Used for tracking user interactions with suggested/recommended content
 */
export class SuggestedRailItemInteraction extends ContentInteraction<Surface> {
  constructor(item: { id: string; __typename: Maybe<ItemType>; attribution: unknown }) {
    super(item)
  }
}
